import { render, staticRenderFns } from "./UserGroupModal.vue?vue&type=template&id=1b43149a&scoped=true"
import script from "./UserGroupModal.vue?vue&type=script&lang=js"
export * from "./UserGroupModal.vue?vue&type=script&lang=js"
import style0 from "./UserGroupModal.vue?vue&type=style&index=0&id=1b43149a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43149a",
  null
  
)

export default component.exports